<template>
    <div class="o-page__inner"
        :data-component-name="$options.name"
    >
        <div class="-two-columns">
            <div class="o-page__loading" v-if="$apollo.loading">
                <q-spinner
                    color="white"
                    size="1em"
                />
                Chargement en cours
            </div>

            <div class="o-row -gutter-xs">
                <div class="o-col w-1/3">
                    <div class="o-col__inner -sticky">
                        <h1 class="o-form__title">Types de ressources</h1>
                        <Listbox
                            v-bind:listbox="listbox"
                            @selected="setSelected"
                            @set-new-item="setNewItem"
                            @delete-item="deleteItem($event)"
                            @duplicate-item="duplicateItem($event)"
                            :deletedShowable="true"
                            @set-show-deleted="showDeleted = $event"
                            :showDeleted="showDeleted"
                        />
                    </div>
                </div>

                <div class="o-col w-2/3">
                    <form
                        @submit.prevent="saveItem(form)"
                        autocomplete="off"
                        class="q-pt-sm"
                    >
                        <fieldset class="o-form__inner">
                            <div class="o-form__title -save-button">
                                <button type="button" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-if="form.id && form.deleted_at" @click.stop="restoreItem(form)">
                                    Restaurer
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-else-if="form.id && !form.deleted_at">
                                    Sauvegarder
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-else>
                                    Ajouter
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                            </div>
                            <!-- <h1 class="o-form__title">Types de ressources</h1> -->
                            <input
                                type="hidden"
                                name="id"
                                v-model="form.id"
                                v-if="form.id"
                            >
                            <div class="o-form__item">
                                <Input
                                    type="text"
                                    name="name"
                                    placeholder="ex. Véhicules"
                                    label="Nom du type de ressources"
                                    v-model="form.name"
                                    required=true
                                    error-message="Ce champ est requis"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <!-- <div class="o-form__item -button -multiple">
                                <button class="o-button" :loading="$apollo.loading" color="primary" v-if="form.id">Sauvegarder</button>
                                <button class="o-button" :loading="$apollo.loading" color="primary" v-if="!form.id">Ajouter</button>
                            </div> -->
                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { RESOURCETYPES } from '@/graphql/resource/queries'
    import { UPSERTRESOURCETYPE, DELETERESOURCETYPE, RESTORERESOURCETYPE } from '@/graphql/resource/mutations'
    import { removeNULL } from '@/js/utilities'

    export default {
        name: "Resources",
        data(){
            return {
                listbox: {
                    selectedItem: { id: -1 },
                    listItems: {},
                    addButton: 'Nouveau',
                    deleteButton: 'Supprimer',
                    copyButton: 'Copier',
                    searchable: 'Rechercher / filtrer'
                },
                searchContactText: null,
                form: {},
                applyToOptions: [],
                newItem: {
                    id: 0,
                    name: null,
                    // type: "OTHER",
                    description: null,
                    tracked: false
                },
                typeOptions: [],
                showDeleted: false,
            }
        },
        mounted: async function(){
            this.listbox.selectedItem=Object.assign({}, this.newItem);
            this.form = Object.assign({}, this.newItem);
            this.$nextTick(() => {
                this.$eventBus.$emit('reset-validation');
            })

        },
        computed: {
            trashed() {
                if (this.showDeleted) return 'ONLY'
                return 'WITHOUT'
            },
        },
        methods: {
            setSelected(item){
                this.listbox.selectedItem = Object.assign({}, item);
                this.form=Object.assign({}, item);
            },
            setNewItem(){
                this.listbox.selectedItem=Object.assign({}, this.newItem);
                this.form=Object.assign({}, this.newItem);
            },
            duplicateItem(){
                this.form.id=null;
                this.form.name=this.form.name + ' - copy'
                this.saveItem(this.form);
            },
            deleteItem(form){
                if( form.id==0 ) return this.setNewItem();

                this.$apollo.mutate({
                    mutation: DELETERESOURCETYPE,
                    variables: { ...form },
                    update: () => {
                        if (this.$apollo.queries.resourceTypes) this.$apollo.queries.resourceTypes.refetch()
                        this.setSelected(null);
                    }
                }).finally(() => {
                    // this.setNewItem();
                })
            },
            saveItem(form) {
                form=removeNULL(form);
                this.$apollo.mutate({
                    mutation: UPSERTRESOURCETYPE,
                    variables: { ...form },
                    update: (store, { data: { upsertResourceType } }) => {
                        if(!form.id){
                            let myVariables = { trashed: this.trashed }
                            const data = store.readQuery({ query: RESOURCETYPES, variables: myVariables })
                            data.resourceTypes.push(upsertResourceType);
                            store.writeQuery({
                                query: RESOURCETYPES,
                                data,
                            })
                        }
                        this.setSelected(upsertResourceType)
                    }
                }).then(() => {
                    this.$q.notify({type: 'positive', message: "Ressource : "+form.name, caption: "Informations sauvegardées"})
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message})
                }).finally(() => {
                })
            },
            restoreItem(form) {
                this.$apollo.mutate({
                    mutation: RESTORERESOURCETYPE,
                    variables: {
                        id: form.id
                    },
                    update: (store, { data: { restoreResourceType } }) => {
                        if(!form.id){
                            const data = store.readQuery({ query: RESOURCETYPES })
                            data.resourceTypes.push(restoreResourceType);
                            store.writeQuery({
                                query: RESOURCETYPES,
                                data,
                            })
                        }
                        this.setSelected(restoreResourceType)
                    }
                }).then(() => {
                    this.$q.notify({type: 'positive', message: "Ressource : "+form.name, caption: "Informations sauvegardées"})
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message})
                }).finally(() => {
                })
            }
        },
        apollo: {
            resourceTypes: {
                query: RESOURCETYPES,
                fetchPolicy: 'cache-and-network',
                variables() {
                    return {
                        trashed: this.trashed
                    }
                },
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(data) {
                    this.listbox.listItems = Object.assign([], data.resourceTypes)
                }
            },
        }
    }
</script>